export const API_URL = `https://forkify-api.herokuapp.com/api/v2/recipes/`;

export const TIMEOUT_SEC = 10;
export const RESULTS_PER_PAGE = 10;
export const KEY = '321da8f1-787a-4c66-862b-393482563391';
export const MODAL_CLOSE_SEC = 1;
